import React from 'react'
import { connect } from 'react-redux'
import { Document, Page } from 'react-pdf';
import styles from './Pdf.module.css';

class PatientCareCenterPdf extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            numPages: 0
        }
        this.pdfContainerRef = React.createRef();
    }

    onDocumentLoadSuccess=()=> {
        if (this.state.numPages !== this.props.numPages) {
            this.setState({ numPages: this.props.numPages });
        }

        const savedScroll = localStorage.getItem(`pdfScrollPosition_${this.props.id}`);
        if (savedScroll) {
          setTimeout(() => {
            this.pdfContainerRef.current.scrollTop = parseInt(savedScroll, 10);
          }, 500);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.noteId !== prevProps.noteId) {
            this.setState({ numPages: 0 });
        }
    }

    componentDidMount() {
        const savedScroll = localStorage.getItem(`pdfScrollPosition_${this.props.id}`);
        if (savedScroll && this.pdfContainerRef.current) {
          this.pdfContainerRef.current.scrollTop = parseInt(savedScroll, 10);
        }
      }

      componentWillUnmount() {
        if (this.pdfContainerRef.current) {
          const scrollTop = this.pdfContainerRef.current.scrollTop;
          localStorage.setItem(`pdfScrollPosition_${this.props.id}`, scrollTop);
        }
      }

      handleScroll = () => {
        if (!this.pdfContainerRef.current) return;
      
        const scrollTop = this.pdfContainerRef.current.scrollTop;
        const storageKey = `pdfScrollPosition_${this.props.id}`;
        const saved = parseInt(localStorage.getItem(storageKey), 10);
      
        // Avoid saving 0 if a non-zero value already exists
        if (scrollTop === 0 && saved > 0) {
          return;
        }
      
        localStorage.setItem(storageKey, scrollTop);
      };

    renderDisplay() {

        if(!this.props.loading && this.props.pdfData){
            return (<div>

                <Document
                    file={{ data: this.props.pdfData }}
                    onLoadSuccess={this.onDocumentLoadSuccess}
                >
                    {[...Array(this.state.numPages).keys()].map(page => (
                        <div key={page} style={{ paddingBottom: '15px' }}>
                            <Page width={1400} pageNumber={page + 1} />
                        </div>
                    ))}
                </Document>
            </div>)
        }
        else {
            return (<div><i>Loading...</i></div>);
            }
    }

    render() {
        return (
            <div className={styles.pdf_wrapper} 
            ref={this.pdfContainerRef} 
            onScroll={this.handleScroll} 
            >
                {this.renderDisplay()}
            </div>
        );
    }
}

function mapStateToProps(state) {
    var pdfData = undefined;
    var numPages = 0;
    var ptno = state.ui.patients.selectedPtno;
    var selectedTab = state.ui.patientCenter[ptno].selectedTab;
    var noteId = state.ui.patientTabs[selectedTab].noteId;
    if (state.entities.pdfs && state.entities.pdfs[noteId]) {
        pdfData = state.entities.pdfs[noteId].pdfData;
        numPages = state.entities.pdfs[noteId].numPages;
    }
   
    return {
        pdfData: pdfData,
        loading: state.ui.pdfs.loading,
        numPages: numPages
    };
}

const connectedPatientCareCenterPdf = connect(mapStateToProps)(PatientCareCenterPdf);
export { connectedPatientCareCenterPdf as PatientCareCenterPdf };
